<template>
  <q-page padding>
    <q-toolbar class="q-px-md">
      <q-toolbar-title class="text-weight-medium"> Dashboard </q-toolbar-title>

      <div>

        <div class="row">

          <date-input
            buttons
            class="q-mr-sm"
            dense
            outlined
            :label="$t('period')"
            :v-model="period"
            @update="
              (val) => {
                period = val;
              }
            "
            today-btn
            range
            label-color="primary"
          />
          <q-btn-dropdown
            no-caps
            outline
            class="q-mr-sm"
            content-style="width: 380px"
            :menu-offset="[0, 10]"
            :label="$t('filters')"
          >
            <q-list separator>
              <div v-for="(filter, index) in Object.values(filters)" :key="index">
                <q-item clickable @click="filter.editing = !filter.editing" class="q-pa-md">
                  <q-item-section>
                    <div :class="isFilterActive(filter) ? 'text-bold' : ''">
                      {{ isFilterActive(filter) ? '->' : '' }}
                      {{ getFilterLabel(filter.name) }}
                    </div>
                  </q-item-section>
                  <q-item-section side>
                    <q-icon :name="filter.editing ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" />
                  </q-item-section>
                </q-item>
                <div class="col-12 q-px-md q-py-sm" v-if="filter.editing">
                  <q-select
                    v-model="filter.value"
                    :options="filter.name == 'statuses' ? statusOptions : filter.optionsFiltered"
                    map-options
                    emit-value
                    :label="getFilterLabel(filter.name)"
                    :option-label="filter.option_label"
                    :option-value="filter.option_value"
                    outlined
                    clearable
                    use-input
                    :multiple="filter.name !== 'channels'"
                    :use-chips="filter.name !== 'channels'"
                    @filter="(val, update) => update(selectFilter(val, index, filter.option_label))"
                    @clear="filter.value = filter.name !== 'channels' ? [] : ''"
                  />
                </div>
              </div>
            </q-list>

            <div class="flex justify-center q-pa-md q-mt-sm">
              <q-btn
                :label="$t('reset_filters')"
                unelevated
                outline
                color="primary"
                style="width: 160px"
                @click="resetFilters"
                no-caps
              />
            </div>
          </q-btn-dropdown>

          <q-btn color="primary" padding="7px 7px" unelevated icon="search" dense @click="getDashboard" />
        </div>
      </div>
    </q-toolbar>
    <!-- <dashboard-main :editGrid="edit" /> -->
    <dashboard-affiliate
      :summary="summary"
      :campaign-metrics="campaignMetrics"
      :exclusive-campaigns="exclusiveCampaigns"
      :main-campaigns="mainCampaigns"
    />
  </q-page>
</template>

<style></style>

<script>
import DashboardAffiliate from '@/components/dashboard/DashboardAffiliate.vue';
import DateInput from '@/widgets/inputsGlobal/DateInput.vue';
import AdvertiserService from '@/services/AdvertiserService.js';
import AffiliateService from '@/services/AffiliateService.js';

export default {
  name: 'PageDashboard',
  components: { DashboardAffiliate, DateInput },
  mixins: [AdvertiserService, AffiliateService],
  mounted() {
    this.retrieveSelectOptions();
    this.getDashboard();
  },
  created() {
    this.period = `${this.$moment().subtract(7, 'days').format('L')} - ${this.$moment().format('L')}`;
  },

  computed: {
    statusOptions() {
      return [
        { label: this.$t('refused'), value: 0 },
        { label: this.$t('pending'), value: 1 },
        { label: this.$t('approved'), value: 2 }
      ];
    },
    campaignLabel() {
      return this.$t('campaign');
    },

    channelLabel() {
      return this.$t('channel');
    }
  },

  data() {
    return {
      //   edit: false
      period: '',
      //   ignoreTestCampaigns: '1',
      summary: {
        conversionValue: 0,
        commissionValue: 0,
        conversionAmount: 0
      },
      campaignMetrics: [],
      exclusiveCampaigns: [],
      mainCampaigns: {
        higherCommission: [],
        convertMore: []
      },

      filters: {
        status: {
          label: 'Status',
          name: 'statuses',
          value: [],
          editing: false
        },
        campaign: {
          name: 'campaigns',
          value: [],
          editing: false,
          options: [],
          optionsFiltered: [],
          option_label: 'campaign_name',
          option_value: 'campaign_id'
        },
        channel: {
          name: 'channels',
          value: '',
          editing: false,
          options: [],
          optionsFiltered: [],
          option_label: 'name',
          option_value: 'id'
        }
      }
    };
  },

  methods: {
    getFilterLabel(filterName) {
      switch (filterName) {
        case 'statuses':
          return 'Status';
        case 'campaigns':
          return this.campaignLabel;
        case 'channels':
          return this.channelLabel;
        default:
          return '';
      }
    },

    isFilterActive(filter) {
      if (Array.isArray(filter.value)) {
        return filter.value.length > 0;
      }
      return !!filter.value;
    },

    periodString() {
      var [startDate, endDate] = this.period.split(' - ');
      return `start_date%3D${this.formatToEn(startDate)}%26end_date%3D${this.formatToEn(endDate)}`;
    },

    async getDashboard() {
      this.params = `${this.periodString()}`;
      const date = `start_date=${this.$moment(this.period.startDate)
        .subtract(3, 'months')
        .startOf('month')
        .format('YYYY-MM-DD')}%26end_date=${this.$moment(this.period.endDate)
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD')}`;

      if (this.filters.status.value.length) {
        this.params += `%26validation_status%3D${this.filters.status.value.join('%2C')}`;
      }
      if (this.filters.campaign.value.length) {
        this.params += `%26campaign_id%3D${this.filters.campaign.value.join('%2C')}`;
      }
      if (this.filters.channel.value) {
        this.params += `%26site_id%3D${this.filters.channel.value}`;
      }

      try {
        this.onLoading(true);

        const [summaryRes, metricsRes, exclusiveRes, higherCommissionRes, convertMoreRes] = await Promise.all([
          // const [summaryRes, metricsRes, exclusiveRes, higherCommissionRes] = await Promise.all([
          this.getDashboardSummaryAffiliate(this.params),
          this.getDashboardCampaignsAffiliate(this.params),
          this.getDashboardExclusiveCampaigns(),
          this.getCampaignsHigherCommission(),
          this.getCampaignsConvertMore(date)
        ]);

        const { data: summary } = summaryRes;
        this.summary = {
          conversionValue: summary.transaction_amount,
          commissionValue: summary.affiliate_commission_cost,
          conversionAmount: summary.quantity_transactions
        };

        this.campaignMetrics = metricsRes.data;
        this.exclusiveCampaigns = exclusiveRes.data;
        this.mainCampaigns.higherCommission = higherCommissionRes.data;
        this.mainCampaigns.convertMore = convertMoreRes.data;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async retrieveSelectOptions() {
      try {
        this.onLoading(true);
        const options = await Promise.all([
          this.getCampaignListAffiliate(this.user.affiliate_id),
          this.getAffiliateSiteActiveListByID(this.user.affiliate_id)
        ]);
        this.filters['campaign'].options = this.filters['campaign'].optionsFiltered = options[0].data;
        this.filters['channel'].options = this.filters['channel'].optionsFiltered = options[1].data;
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    selectFilter(val, index, prop = null) {
      const needle = val.toLocaleLowerCase();
      const filters = Object.values(this.filters);
      filters[index].optionsFiltered = needle
        ? filters[index].options.filter((v) =>
            prop ? v[prop].toLocaleLowerCase().includes(needle) : v.toLocaleLowerCase().includes(needle)
          )
        : filters[index].options;
    },

    resetFilters() {
      let reload = false;
      Object.keys(this.filters).forEach((key) => {
        if (this.isFilterActive(this.filters[key])) {
          reload = true;
        }
        if (Array.isArray(this.filters[key].value)) {
          this.filters[key].value = [];
        } else {
          this.filters[key].value = '';
        }
      });
      if (reload) this.getDashboard();
      this.filters.status.editing = false;
      this.filters.campaign.editing = false;
      this.filters.channel.editing = false;
    }
  }
};
</script>
